// Cambiar esta línea:

import { supabase } from './supabaseClient.js';
import { logError } from '../lib/utils.js';

class CotizacionesService {
  static async getCotizaciones(filters = {}) {
    try {
      let query = supabase
        .from('cotizaciones')
        .select(`
          *,
          planes(nombre, uf_base, capital_uf),
          producto(nombre)
        `);

      // Aplicar filtros de fecha si se proporcionan
      if (filters.fechaInicio) {
        query = query.gte('fecha', filters.fechaInicio);
      }
      if (filters.fechaFin) {
        query = query.lte('fecha', filters.fechaFin);
      }

      const { data, error } = await query.order('fecha', { ascending: false });

      if (error) {
        logError('Error al obtener cotizaciones:', error, { ignoreAbort: true });
        throw error;
      }

      return data || [];
    } catch (error) {
      logError('Error en getCotizaciones:', error, { ignoreAbort: true });
      throw error;
    }
  }

  // Método para obtener estadísticas de cotizaciones
  static async getEstadisticas(filters = {}) {
    try {
      const cotizaciones = await this.getCotizaciones(filters);
      
      // Agrupar por fecha y calcular estadísticas usando el resumen JSON
      const groupedData = cotizaciones.reduce((acc, cotizacion) => {
        const fecha = new Date(cotizacion.fecha).toISOString().split('T')[0];
        
        // Obtener el monto UF del resumen JSON
        let montoUF = 0;
        if (cotizacion.resumen) {
          try {
            const resumen = typeof cotizacion.resumen === 'string' 
              ? JSON.parse(cotizacion.resumen) 
              : cotizacion.resumen;
            
            // Usar el total.primaUF del resumen
            montoUF = resumen?.total?.primaUF || 0;
          } catch (error) {
            logError('Error parsing resumen JSON:', error);
            // Fallback al uf_base del plan si el resumen no es válido
            montoUF = cotizacion.planes?.uf_base || 0;
          }
        } else {
          // Fallback al uf_base del plan si no hay resumen
          montoUF = cotizacion.planes?.uf_base || 0;
        }
        
        if (!acc[fecha]) {
          acc[fecha] = { fecha, total_uf: 0, count: 0 };
        }
        
        acc[fecha].total_uf += montoUF;
        acc[fecha].count += 1;
        
        return acc;
      }, {});
      
      return Object.values(groupedData)
        .sort((a, b) => new Date(a.fecha) - new Date(b.fecha));
    } catch (error) {
      logError('Error en getEstadisticas:', error, { ignoreAbort: true });
      throw error;
    }
  }
}

export default CotizacionesService;
